import RoutingComponent from "../../../base/common/RoutingComponent";
import styles from "./index.module.scss";
import reportCenterIcon from "../../../assets/image/reportCenterIcon.png";
import arrowIcon from "../../../assets/image/arrow.png";
import {
  PmpMetricButtons,
  shouldShowDataNotGeneratedBanner,
  DATA_NOT_GENERATED_BANNER_TITLE,
  DATA_NOT_GENERATED_BANNER_MESSAGE,
} from "./constants";
import uploadIcon from "./assets/upload.svg";
import classNames from "classnames";
import MonitoringReportUploadModal from "./components/monitoringReportUpload";
import { handleUserRoleOnlyOpex } from "utils";
import AppSetting from "../../../config/AppSetting";

export default class ReportCenter extends RoutingComponent {
  state = {
    isMonitoringReportUploadModalOpen: false,
  };

  reportItemClick = (parameters: any) => {
    window.open(`/ReportCenter/ReportDetail/${parameters}`, "_blank");
  };

  toggleMonitoringReportUploadModal = (flag: any) => {
    this.setState({ isMonitoringReportUploadModalOpen: flag });
  };

  componentDidMount() {
    this.validateToken();
  }

  renderPmpMonitoringReportCard = () => {
    const isOpex = handleUserRoleOnlyOpex(AppSetting.localStorageValue.role.get());
    return (
      <div
        className={classNames(styles.reportItem, styles.pmpMonitoringReportCard)}
        onClick={() => this.reportItemClick("MonitoringReport")}
        data-testid="pmp-monitoring-report-card"
        role="button"
        tabIndex={0}
      >
        <div
          className={classNames(styles.pmpCardHeader, {
            [styles.pmpCardHeaderWithoutOpex]: !isOpex,
          })}
        >
          <img className={styles.icon} src={reportCenterIcon} alt="" />
          <div className={styles.reportItemContent}>
            <div className={styles.itemTitle}>PMP Monitoring Report</div>
            <div className={styles.itemDescription}>
              This report displays PMP compliance results, providing audit summaries at the center,
              metric, and account levels, along with key non-compliance details such as task
              information, metrics with issues, and issue types.
            </div>
            {shouldShowDataNotGeneratedBanner() && (
              <div
                className={styles.dataNotGeneratedBanner}
                data-testid="pmp-monitoring-report-data-not-generated-banner"
              >
                <span className={styles.dataNotGeneratedBannerTitle}>
                  {DATA_NOT_GENERATED_BANNER_TITLE}
                </span>
                {DATA_NOT_GENERATED_BANNER_MESSAGE}
              </div>
            )}
          </div>
          <img className={styles.arrowIcon} src={arrowIcon} alt="" />
        </div>
        {isOpex && (
          <div className={styles.metricButtonsSection} onClick={(event) => event.stopPropagation()}>
            <div className={styles.metricButtonsRow}>
              {PmpMetricButtons.slice(0, 4).map(({ label, link }, index) => (
                <button
                  key={label}
                  className={classNames(styles.metricButton, {
                    "flex-[1.2]": index === 1,
                  })}
                  onClick={() => this.reportItemClick(link)}
                  data-testid={`pmp-metric-${label.toLowerCase().replace(/[_\s]+/g, "-")}-btn`}
                >
                  {label}
                </button>
              ))}
            </div>
            <div className={styles.metricButtonsRow}>
              {PmpMetricButtons.slice(4).map(({ label, link }, index) => (
                <button
                  key={label}
                  className={classNames(styles.metricButton, {
                    "flex-[1.67]": index === 0,
                    "flex-[2.2]": index === 1,
                  })}
                  onClick={() => this.reportItemClick(link)}
                  data-testid={`pmp-metric-${label.toLowerCase().replace(/[_\s]+/g, "-")}-btn`}
                >
                  {label}
                </button>
              ))}
            </div>
            <button
              className={styles.uploadButton}
              onClick={() => this.toggleMonitoringReportUploadModal(true)}
              data-testid="upload-metric-report-btn"
            >
              <img src={uploadIcon} alt="" />
              Upload Metric Report
            </button>
          </div>
        )}
      </div>
    );
  };

  render() {
    const { isMonitoringReportUploadModalOpen } = this.state;

    const reportItemComponent = (title: any, description: any, link: any) => {
      return (
        <div
          className={styles.reportItem}
          onClick={() => this.reportItemClick(link)}
          data-testid={`report-${link.toLowerCase()}-btn`}
          role="button"
          tabIndex={0}
        >
          <img className={styles.icon} src={reportCenterIcon} alt="" />
          <div className={styles.reportItemContent}>
            <div className={styles.itemTitle}>{title}</div>
            <div className={styles.itemDescription}>{description}</div>
          </div>
          <img className={styles.arrowIcon} src={arrowIcon} alt="" />
        </div>
      );
    };

    return (
      <div className={styles.reportCenter}>
        <div className={styles.pageHead}>
          <div className={styles.title}>REPORT CENTER</div>
          <div className={styles.description}>
            Access to the listed reports depends on user's PMP account permissions. Please refer to
            the system guideline for the information on PMP account permissions.
          </div>
        </div>
        <div className={styles.pageContent}>
          {reportItemComponent(
            "Procedure Master List",
            "This report displays procedure information on specific tasks, providing key details such as task info., procedure status, procedure storage, procedure owner, shared tasks, latest version, etc.",
            "ProcedureMasterList"
          )}
          {reportItemComponent(
            "Procedure Update Tracking Log",
            "This report displays all requests for procedure changes, providing key details such as the status of procedure updates and audit, and client's sign-off info., etc.",
            "ProcedureUpdateTrackingLog"
          )}
          {reportItemComponent(
            "Team Leader Procedure Review Tracking Log",
            "This report displays details of procedure reviews by team leaders, providing key details such as reviewer, review date, and review results, etc.",
            "TeamLeaderProcedureReviewTrackingLog"
          )}
          {reportItemComponent(
            "Sharing Relationship Tracking Log",
            "This report displays all changes in sharing relationship, providing key details such as change date, change specifics, and the tasks within the sharing relationship following the change, etc.",
            "SharingRelationshipTrackingLog"
          )}
          {reportItemComponent(
            "PMP Process List",
            "This report displays all processes of each task at both the request and step levels, providing key details such as process status, process owner, and due date, etc.",
            "ProcessList"
          )}
          {reportItemComponent(
            "PMP File List",
            "This report displays all active and archived procedure and supporting files related to specific tasks, providing key details such as file type, file status, upload info., and approval info.",
            "FileList"
          )}
          {this.renderPmpMonitoringReportCard()}
        </div>
        <MonitoringReportUploadModal
          visible={isMonitoringReportUploadModalOpen}
          onToggle={this.toggleMonitoringReportUploadModal}
        />
      </div>
    );
  }
}
